import { createFeatureSelector, createSelector } from '@ngrx/store';
import { addExtensionGroupFeatureKey, AddExtensionGroupState } from './add-extension-group.reducer';

const getAddExtensionGroupFeature = createFeatureSelector<AddExtensionGroupState>(addExtensionGroupFeatureKey);

export const getAddExtensionGroupCallState = createSelector(getAddExtensionGroupFeature, (state) => {
   return state.callState;
});
